import { reactive } from "vue";
import { RMDFaqStore } from "@/store/types/RMDFaqStore";

const rmdFaqs = reactive(new RMDFaqStore());

export { rmdFaqs };
